/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useState} from 'react'
import {getUnitBranchAllSimple} from '../../../../../../services/unitBranchService'
import {Loading} from '../../../../../components/Loadings/loading'
import {useToast} from '../../../../../components/Toats'
import {ListUnitBranchLinked} from '../listUnitBranchLinked'
import {CatalogImageUpload} from '../../../../../catalogo/components/CatalogImageUpload'

const StepModal = ({hasError, formik}: any) => {
  const {toggleToast} = useToast()
  const [unitBranchs, setUnitBranchs] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  const getUnitBranchs = async () => {
    try {
      setLoading(true)
      const response = await getUnitBranchAllSimple()
      setUnitBranchs(response)
    } catch (error) {
      console.log(error)
      toggleToast('Erro ao buscar a lista de unidades.', 'error')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUnitBranchs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          height: '15rem',
          alignItems: 'center',
        }}
      >
        <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}} />
      </div>
    )
  }

  return (
    <div className='current' data-kt-stepper-element='content' style={{maxHeight: '55vh', overflow: 'auto'}}>
      <div className='w-100'>
        <CatalogImageUpload
          label='Foto do serviço'
          imageKey={formik.values.image}
          onChange={(key) => formik.setFieldValue('image', key)}
        />

        <div className='row g-5 mb-8'>
          <div className='col-md-7'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Nome</span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='description'
              placeholder='Ex: Manutenção preventiva'
              value={formik.values.description || ''}
              onChange={formik.handleChange('description')}
            />
            {!formik.values.description && hasError && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>Informe o nome do serviço</div>
              </div>
            )}
          </div>

          <div className='col-md-5'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>R$ Preço</span>
            </label>
            <input
              type='number'
              className='form-control form-control-lg form-control-solid'
              name='preco'
              placeholder='0,00'
              value={formik.values.preco ?? ''}
              onChange={formik.handleChange('preco')}
            />
          </div>
        </div>

        <div className='fv-row mb-8'>
          <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
            <span>Descrição</span>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            name='details'
            rows={4}
            placeholder='Detalhes do serviço, especificações, observações...'
            value={formik.values.details || ''}
            onChange={formik.handleChange('details')}
          />
        </div>

        <ListUnitBranchLinked
          unitBranchs={unitBranchs}
          className="className='card-xl-stretch bg-light mb-xl-8"
          formik={formik}
        />
      </div>
    </div>
  )
}

export {StepModal}
